<template>
  <div>
    <header>
      <div class="container">
        <a class="logo" href="https://fas.gov.ru/" target="_blank">
          <img src="@/assets/img/fas_logo2.png" alt="" id="logo2" height="80px">
        </a>
        <a class="logo" href="https://emc-fas.ru/" target="_blank">
          <img src="@/assets/img/fas_logo.png" alt="" id="logo" height="80px">
        </a>
        <slot>

        </slot>
        <div class="username-wrapper">
          <router-link v-if="$router.currentRoute.name != 'Index'" class="logo" :to="{name: 'Index'}">
            На главную
          </router-link>
        </div>
      </div>
    </header>
  </div>
</template>
<script>

  export default {
    name: 'Header',
    data () {
      return {
        clicked: false
      }
    },
    methods: {
      usernameClick () {
        this.clicked = !this.clicked
      },
      logout () {
        this.clicked = false
        this.$store.dispatch('signout')
        this.$router.push({name: 'Index'})
      }
    },
    computed: {
      username () {
        let user = this.$store.getters.getAuthUser
        if (user) {
          let fio = `${user.last_name} ${user.first_name[0]}. `
          fio += user.middle_name ? user.middle_name[0] + '.' : ''
          return fio
        }
        return null
      },
      playername () {
        let player = this.$store.getters.getPlayer
        if (player) {
          let fio = `${player.last_name} ${player.first_name[0]}. `
          fio += player.middle_name ? player.middle_name[0] + '.' : ''
          return fio
        }
        return null
      }
    }
  }
</script>
<style lang="scss">
  header {
    //background-color: $blue;
    color: #437683;
    padding: 10px 0;
    @media screen and (max-width: 500px) {
      font-size: 11px;
      padding: 5px 0;
    }
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
    .logo {
      font-size: 1.5em;
      color: #437683;
      text-decoration: none;
      font-weight: bold;
      @media screen and (max-width: 500px) {
        width: 100%;
        text-align: center;
        margin-bottom: 15px;
      }
    }
    .username-wrapper {
      @media screen and (max-width: 500px) {
        white-space: nowrap;
        width: 100%;
        text-align: center;
      }
    }
    .username {
      font-size: 1.2em;
      cursor: pointer;
      @media screen and (max-width: 500px) {
        white-space: nowrap;
      }
    }
  }

  .arrowUp {
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #437683;
    position: relative;
    top: -4px;
  }

  .arrowDown {
    display: inline-block;
    position: relative;
    top: -4px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #437683;
  }

  .dropdown {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    .dropdown-content {
      position: absolute;
      top: 65px;
      right: 0;
      background-color: #fff;
      font-weight: 300;
      color: #000;
      padding: 10px 10px;
      width: 90px;
      text-align: center;
      border: 1px solid $light-blue;
      cursor: pointer;
      border-radius: 2px;
      z-index: 100;
      &:after {
        display: block;
        content: '';
        width: 10px;
        height: 10px;
        border: 1px solid $light-blue;
        border-bottom: none;
        border-right: none;
        transform: rotate(45deg);
        background-color: #fff;
        position: absolute;
        top: -6px;
        right: 20px;
      }
      i, span {
        display: inline-block;
        margin: 0 5px;
      }
      svg {
        fill: #6FABD4;
      }
      span:hover {
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue